export enum DashboardPageSlug {
  SMART_INSIGHTS = 'smart-insights',
  PIPELINE_HEALTH = 'pipeline-health',
  CONVERSION_METRICS = 'conversion-metrics',
  TREND_METRICS = 'trend-metrics',
  PARTNER_SCORECARD = 'partner-scorecard',
}

export interface DashboardPageDefinition {
  slug: DashboardPageSlug;
  navLabel: string;
  title: string;
  subtitle: string;
  /** Whether the filter bar offers the period segments and shows the period range; absent means shown. */
  showPeriod?: boolean;
}

export const DASHBOARDS_NAV_LABEL = 'Dashboards';

// Single source for routes, nav sub-items, page headings and browser titles (Figma order and copy).
export const DASHBOARD_PAGES: DashboardPageDefinition[] = [
  {
    slug: DashboardPageSlug.SMART_INSIGHTS,
    navLabel: 'Smart insights',
    title: 'Smart insights',
    subtitle: 'What matters right now, without digging through the pipeline.',
  },
  {
    slug: DashboardPageSlug.PIPELINE_HEALTH,
    navLabel: 'Pipeline health',
    title: 'Pipeline health',
    subtitle: 'Where are my deals getting stuck? Status distribution with aging flags and derived rates.',
  },
  {
    slug: DashboardPageSlug.CONVERSION_METRICS,
    navLabel: 'Conversion metrics',
    title: 'Conversion metrics',
    subtitle: 'How effective am I as a partner? Stage-to-stage conversion.',
  },
  {
    slug: DashboardPageSlug.TREND_METRICS,
    navLabel: 'Trend metrics',
    title: 'Trend metrics',
    subtitle: 'Am I improving? Submitted, approved and funded volume over time.',
  },
  {
    slug: DashboardPageSlug.PARTNER_SCORECARD,
    navLabel: 'Partner scorecard',
    title: 'Partner scorecard',
    subtitle: 'Your funded volume, submission activity, approval and booking rates over time, in the portal.',
    // Trailing months and all time, whatever the period.
    showPeriod: false,
  },
];
